import type { Map } from '../types';

const brands: Map = {
    FINN: 'nb',
    TORI: 'fi',
    DBA: 'da',
    BLOCKET: 'sv',
    LOCALHOST: 'nb',
};

const brandToLangFormatter = {
    format: String,
    name: 'brand-to-lang',
    /**
     * validate whether the value is a string
     * @param {any} value
     */
    validate: (value: unknown) => {
        if (typeof value !== 'string') {
            throw new Error('Value must be a String');
        }
    },
    /**
     * coerce the value to a lang if valid
     * @param {string} value
     * @returns {(string | void)}
     */
    coerce: (value: string) => {
        const locale = brands[value.toUpperCase()];
        if (locale) {
            return locale;
        }
        throw new Error(
            `Unknown brand: ${value}, I only know about ${Object.keys(brands).join(', ')}`,
        );
    },
};

export default brandToLangFormatter;
